import { useRef } from "react";

export default function OtpInput({
  value,
  onChange,
  length = 6,
}) {

  const inputs = useRef([]);

  const handleChange = (val, index) => {

    if (!/^\d?$/.test(val)) return;

    const newValue = [...value];

    newValue[index] = val;

    onChange(newValue);

    if (val && index < length - 1) {
      inputs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {

    if (
      e.key === "Backspace" &&
      !value[index] &&
      index > 0
    ) {
      inputs.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {

    e.preventDefault();

    const pasted = e.clipboardData
      .getData("Text")
      .replace(/\D/g, "")
      .slice(0, length);

    if (!pasted) return;

    const arr = pasted.split("");

    while (arr.length < length) {
      arr.push("");
    }

    onChange(arr);

    const lastIndex = Math.min(
      pasted.length,
      length
    ) - 1;

    inputs.current[lastIndex]?.focus();
  };

  return (
    <div
      dir="ltr"
      className="flex w-full justify-center gap-2"
      onPaste={handlePaste}
      aria-label="کد تأیید شش رقمی"
    >
      {Array.from({ length }).map((_, index) => (
        <input
           dir="ltr"
    style={{ direction: "ltr" }}
          key={index}
          ref={(el) => (inputs.current[index] = el)}
          type="text"
          inputMode="numeric"
          autoComplete={index === 0 ? "one-time-code" : "off"}
          aria-label={`رقم ${index + 1} کد تأیید`}
          maxLength={1}
          value={value[index] || ""}
          onChange={(e) =>
            handleChange(
              e.target.value,
              index
            )
          }
          onKeyDown={(e) =>
            handleKeyDown(
              e,
              index
            )
          }
          className="
            h-12
            w-11
            sm:h-14
            sm:w-12
            rounded-xl
            border border-gray-200
            text-center
            text-xl
            font-bold
            outline-none
            transition-all duration-200
            hover:border-gray-300
            focus:border-primary
            focus:ring-4
            focus:ring-primary/10
          "
        />
      ))}
    </div>
  );
}
